import { SortDirection, UserSortBy } from '../../../../../utils/types/types';
import { BaseContextServiceV3 } from '../../../base-context.service';
import { UserDetailsDto } from '../../dto/response/user-details.dto';
import { UserDtoInfiniteScrollResultDto } from '../../dto/response/user-infinite-scroll-result.dto';

class UserService extends BaseContextServiceV3 {
  public async fetchUsers(
    searchTerm?: string,
    roleIds?: string[],
    isInactive?: boolean,
    page: number = 1,
    pageSize: number = 10,
    sortBy: UserSortBy = 'name',
    sortDirection: SortDirection = 'asc'
  ): Promise<UserDtoInfiniteScrollResultDto> {
    const params = new URLSearchParams({
      Page: String(page),
      PageSize: String(pageSize),
      SortBy: sortBy,
      SortDirection: sortDirection,
    });

    if (searchTerm) {
      params.append('SearchTerm', searchTerm);
    }

    if (typeof isInactive === 'boolean') {
      params.append('IsInactive', String(isInactive));
    }

    if (roleIds?.length) {
      roleIds.forEach((id) => params.append('RoleIds', id));
    }

    const response = await this.get<UserDtoInfiniteScrollResultDto>(
      `/users?${params.toString()}`
    );
    return response.data;
  }

  public async fetchUserById(id: string): Promise<UserDetailsDto> {
    const response = await this.get<UserDetailsDto>(`/users/${id}`);
    return response.data;
  }

  public async deleteUser(id: string): Promise<void> {
    await this.delete<void>(`/users/${id}`);
  }

  public async exportUsersData() {
    const response = await this.get<any>('/users/export', {
      responseType: 'blob',
    });

    return response.data;
  }
}

const userServiceV3 = new UserService();
export default userServiceV3;
